import * as React from 'react';

{/* tslint:disable:max-line-length */}
export const BatchEntryIntro = (props: { paymentNoun: string }) => (
	<p className="lead">Batch Entry helps you to enter and group multiple {props.paymentNoun} to Pushpay. You can also apply settings to update service time, payment methods, funds and received on date to multiple items quickly.</p>
);
